import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../../../common_components/common_btn/purple_btn/Purple_Btn";
import Purple_border_btn from "../../../../common_components/common_btn/purple_border_btn/Purple_border_btn";

import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { postAddress } from "../../../../../utils/apis/orderProcess/orderProcess";
import { Controller, useForm } from "react-hook-form";
import { RegxExpression } from "../../../../../utils/common";
import { Select2Data } from "../../../../../utils/api";
import {
  City,
  Country,
  Pincode,
  State,
} from "../../../../../utils/apis/master/Master";

function Step4_Delivery({ goToStep, user }) {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
    setValue,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("prefix", data?.prefix);
    formData.append("l_name", data?.l_name);
    formData.append("f_name", data?.f_name);
    formData.append("location", data?.location);
    formData.append("m_name", data?.m_name);
    formData.append("company", data?.company);
    formData.append("state_id", data?.state_id.value);
    formData.append("country_id", data?.country_id?.value);
    formData.append("city_id", data?.city_id.value);
    formData.append("address", data?.address);
    formData.append("pincode_id", data?.pincode_id?.value);
    formData.append("contact_no", data?.contact_no);
    formData.append("type", "Billing Information");

    const res = await postAddress(formData);
    if (res?.success) {
      goToStep(1);
      // idis = res?.data?.id;
      // await setShippingId(res?.data?.id);
      // handleNext();
      // props.onHide()
      // props.getAllData()
    } else {
      if (res?.message?.gst_number) {
        setError("gst_number", { message: res?.message?.gst_number });
      }
    }
  };

  const [country, setCountry] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [pincode, setPincode] = useState([]);
  const GetAllCountries = async () => {
    const response = await Country();
    if (response?.success) {
      setCountry(await Select2Data(response?.data, "country_id"));
    }
  };
  const GetAllStates = async (id) => {
    const response = await State(id);
    if (response?.success) {
      setStates(await Select2Data(response?.data, "state_id"));
    }
  };

  const GetAllCities = async (id) => {
    const response = await City(id);
    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };
  const GetAllPincode = async (id) => {
    const response = await Pincode(id);
    if (response?.success) {
      setPincode(await Select2Data(response?.data, "pincode_id"));
    }
  };

  useEffect(() => {
    GetAllCountries();
  }, []);
  return (
    <>
      <div className="content_box_holder mt-3">
        <div className="heading_strip_holder">
          <div className="content_strip_holder">
            <div>
              <h1>Account</h1>
            </div>
          </div>
          <hr />
        </div>

        <div className="content_strip_holder">
          <p>{user?.email}</p>
          {/* <FontAwesomeIcon icon={faPenToSquare} /> */}
        </div>
      </div>

      <div className="content_box_holder mt-3">
        <div className="heading_strip_holder">
          <div className="content_strip_holder">
            <div>
              <h1>Delivery</h1>
            </div>
          </div>
          <hr />
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <p>
            The content of your cart is not eligible for delivery to this
            address, please create a valid address.
          </p>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>Location*</Form.Label>
                <Form.Control
                  type="text"
                  name="location"
                  placeholder="Enter Location"
                  {...register("location", {
                    required: "Location required",
                  })}
                />
                {errors.pincode_id && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.location.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Prefix</Form.Label>
                <Form.Select
                  className="form-control"
                  aria-label="Default select example"
                  placeholder="Select Prefix"
                  {...register("prefix", {
                    required: "Prefix is required",
                  })}
                >
                  <option value="">Select Prefix</option>
                  <option value="Ms">Ms</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Mr">Mr</option>
                </Form.Select>

                {errors.prefix && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.prefix.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>First Name*</Form.Label>
                <Form.Control
                  type="text"
                  name="F_Name"
                  placeholder="Enter First Name"
                  {...register("f_name", {
                    required: "First name required",
                  })}
                  onKeyDown={(event) => {
                    if (!RegxExpression.name.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                {errors.f_name && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.f_name.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Middle Name*</Form.Label>
                <Form.Control
                  type="text"
                  name="m_name"
                  placeholder="Enter Middle Name"
                  {...register("m_name", {
                    // required: " Middle Name required",
                  })}
                  onKeyDown={(event) => {
                    if (!RegxExpression.name.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                {/* <div className="error_text_holder">
                  <p>
                    <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                    Required Information
                  </p>
                </div> */}
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Last Name*</Form.Label>
                <Form.Control
                  type="text"
                  name="l_name"
                  placeholder="Enter Last Name"
                  {...register("l_name", {
                    required: "Last Name required",
                  })}
                  onKeyDown={(event) => {
                    if (!RegxExpression.name.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                {errors.l_name && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.l_name.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  name="company"
                  placeholder="Enter Company Name"
                  {...register("company", {
                    required: "company required",
                  })}
                />
                {errors.company && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.company.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>Address*</Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  placeholder="Address"
                  {...register("address", {
                    required: "address required",
                  })}
                />
                {errors.address && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.address.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Country*</Form.Label>

                <Controller
                  name="country_id" // name of the field
                  {...register("country_id", {
                    required: "Select Country",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.country_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={country}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption); // Update Controller's value
                        GetAllStates(selectedOption.value);
                        setValue("country_id", selectedOption);
                        setValue("state_id", null);
                        setValue("city_id", null);
                        setValue("pincode_id", null);
                      }}
                    />
                  )}
                />

                {errors.country_id && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.country_id.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>State/Province*</Form.Label>
                <Controller
                  name="state_id" // name of the field
                  {...register("state_id", {
                    required: "Select State",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.state_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={states}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption); // Update Controller's value
                        GetAllCities(selectedOption.value);
                        setValue("state_id", selectedOption);
                        setValue("city_id", null);
                        setValue("pincode_id", null);
                      }}
                    />
                  )}
                />

                {errors.state_id && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.state_id.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>City*</Form.Label>
                <Controller
                  name="city_id" // name of the field
                  {...register("city_id", {
                    required: "Select City",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.city_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={cities}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption); // Update Controller's value
                        GetAllPincode(selectedOption.value);
                        setValue("city_id", selectedOption);
                        setValue("pincode_id", null);
                      }}
                    />
                  )}
                />

                {errors.city_id && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.city_id.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>PinCode*</Form.Label>
                <Controller
                  name="pincode_id" // name of the field
                  {...register("pincode_id", {
                    required: "Select pincode",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.pincode_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={pincode}
                    />
                  )}
                />

                {errors.pincode_id && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors.pincode_id.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Contact No.*</Form.Label>

                <Controller
                  name="contact_no"
                  control={control}
                  rules={{
                    required: "Field is required",
                  }}
                  render={({ field }) => (
                    <PhoneInput
                      country={"in"}
                      {...field}
                      onChange={(value) => field.onChange(value)}
                      placeholder="Enter Mobile Number"
                    />
                  )}
                />

                {errors?.contact_no && (
                  <div className="error_text_holder">
                    <p>
                      <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                      {errors?.contact_no?.message}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="btn_holder">
            <div onClick={() => goToStep(1)}>
              <Purple_border_btn btnText="Back" />
            </div>

            {/* <div onClick={() => goToStep(1)}>
              <Purple_Btn btnText="Save" />
            </div> */}
            <div>
              <Purple_Btn btnText="Save" type="submit" />
            </div>
          </div>
        </Form>
      </div>

      {/* <div className="content_box_holder mt-3">
        <div className="heading_strip_holder">
          <div className="content_strip_holder">
            <h1>Payment</h1>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Step4_Delivery;
